<template>
	<div class="app-container">
		<div class="header">
			<el-input size="medium" v-model="search" :placeholder="this.$t('usersmanage.searchviaphone')" @keyup.enter.native="userSearch()"
				class="search" />
				<el-button icon="el-icon-search" @click="userSearch()" type="primary" class="btnInsert" >{{$t('usersmanage.btnsearch')}}</el-button>
			<!-- <el-button style="height: 30px; font-size: 10px; line-height: 10px;">查询</el-button> -->
			<el-button type="success" size="mini" @click="openInsertUser" class="btnInsert">{{$t('usersmanage.btninsertuser')}}
			</el-button>

		</div>
		<el-table :data="users" style="width: 100%">
			<el-table-column label="id"  prop="" width="180px" show-overflow-tooltip>
				<template slot-scope="scope">
					<el-span type='text'>{{scope.row.userId}}</el-span>
				</template>
			</el-table-column>

			<el-table-column :label="this.$t('usersmanage.username')" prop="username" width="180"> </el-table-column>
			<el-table-column :label="this.$t('usersmanage.phone')" width="180">
        <template #default="scope">
          {{ scope.row.phone || scope.row.email || '' }}
        </template>
      </el-table-column>
			<el-table-column prop="" :label="this.$t('usersmanage.avatar')" width="180">
				<template slot-scope="scope">
					<img :src="scope.row.image" slot="" alt="" class="avatar" />
				</template>
			</el-table-column>

			<el-table-column :label="this.$t('usersmanage.registtime')" prop="createTime" width="180"> </el-table-column>


			<el-table-column :label="this.$t('usersmanage.equipment')" prop="equipment" width="150">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.equipment === 0" type="success">{{$t('usersmanage.equipment1')}}</el-tag>
					<el-tag v-if="scope.row.equipment === 1" type="success">{{$t('usersmanage.equipment2')}}</el-tag>
					<el-tag v-if="scope.row.equipment === 2" type="success">{{$t('usersmanage.equipment3')}}</el-tag>
					<el-tag v-if="scope.row.equipment === 3" type="success">{{$t('usersmanage.equipment4')}}</el-tag>
					<!-- <el-tag type="danger" v-else>否</el-tag> -->
				</template>
			</el-table-column>

			<el-table-column :label="this.$t('usersmanage.owncar')" width="150">
				<template slot-scope="scope">
					<!-- 嵌套框 -->
					<el-button type="info" @click="tableClick(scope.row.userId,scope.row.username,true)">
						{{scope.row.haveCar}}
					</el-button>
					<el-drawer :visible.sync="table" direction="rtl" size="55%">
						<i style="font-size: 20px; margin-left: 20px;">{{username}}{{$t('usersmanage.carsinfo')}}</i>
						<el-table :data="carInfo" style="padding-left: 10px;">
							<el-table-column width="100" prop="brandE" label="Brand" ></el-table-column>
							<el-table-column width="100" prop="year" label="Year"></el-table-column>
							<el-table-column width="150" prop="configuration" label="Configuration"></el-table-column>
							<el-table-column width="180" prop="createTime" label="Create time"></el-table-column>
							<el-table-column width="200" prop="vin" label="vin"></el-table-column>
							<el-table-column width="120" prop="license" label="License plate"></el-table-column>
							<el-table-column label="Modify" prop="" fixed="right">
								<template slot-scope="scope">
									<el-tag type="warning" class="btn" @click="updateOneCar(scope.row)">{{$t('usersmanage.carsinfo_operate_modify')}}</el-tag>
									<el-tag type="danger" class="btn" @click="deleteOneCar(scope.row.id)">{{$t('usersmanage.carsinfo_operate_delete')}}</el-tag>
								</template>
							</el-table-column>
						</el-table>
					</el-drawer>
				</template>
			</el-table-column>

			<el-table-column :label="this.$t('usersmanage.operate1')" prop="">
				<template slot-scope="scope">
					<el-tag class="btn" @click="updateUserPwd(scope.row)">{{$t('usersmanage.operate1_modifypassword')}}</el-tag>
					<el-tag type="warning" class="btn" @click="updateUserInfo(scope.row)">{{$t('usersmanage.operate1_modifyinfo')}}</el-tag>
					<el-tag type="danger" class="btn" @click="deleteUserInfo(scope.row.userId)">{{$t('usersmanage.operate1_delete')}}</el-tag>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
			:page-sizes="[5, 10, 15, 20]" :page-size="length" layout="total, sizes, prev, pager, next, jumper"
			:total="total" class="pagination">
		</el-pagination>

		<!-- 用户框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="form">
				<el-form-item label="Id" :label-width="formLabelWidth">
					<el-input v-model="form.userId" autocomplete="off" @input="change($event)" :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.modifyinfo_name')" :label-width="formLabelWidth">
					<el-input v-model="form.username" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.modifyinfo_phone')" :label-width="formLabelWidth">
					<el-input v-model="form.phone" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.modifyinfo_pwd')" :label-width="formLabelWidth" v-if="dialogTitle == this.$t('usersmanage.insertuser_title')">
					<el-input v-model="form.password" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-switch v-if="dialogTitle == this.$t('usersmanage.modifyinfo_title')" style="display: block; margin-left: 60px;"
					v-model="form.enabled" active-color="#13ce66" inactive-color="#ff4949" :active-text="this.$t('usersmanage.modifyinfo_unabled')"
					:inactive-text="this.$t('usersmanage.modifyinfo_enabled')" @input="change($event)">
				</el-switch>

				<!-- <i>用户头像</i>
				<el-upload class="avatar-uploader" :action="myaction"
					:show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
					<img v-if="user.image" :src="user.image" class="avatar1">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible=false">{{$t('usersmanage.modifyinfo_cancel')}}</el-button>
				<el-button type="primary" @click="toUser()">{{btnName}}</el-button>
			</div>
		</el-dialog>
		<!-- 用户车辆框 -->
		<el-dialog :title="this.$t('usersmanage.carsinfo_modify_title')" :visible.sync="cardialogFormVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="carform">
				<el-form-item :label="this.$t('usersmanage.carsinfo_id')">
					<el-input v-model="carform.id" autocomplete="off" disabled="true"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.carsinfo_brand')">
					<el-input v-model="carform.brandC" autocomplete="off" disabled="true"></el-input>
					<!-- <el-input v-model="carform.brandE" autocomplete="off" disabled="true" v-if=chinese></el-input> -->
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.carsinfo_year')">
					<el-input v-model="carform.year" autocomplete="off" disabled=true></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.carsinfo_configuration')">
					<el-input v-model="carform.configuration" autocomplete="off" disabled="true"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.carsinfo_vin')">
					<el-input v-model="carform.vin" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.carsinfo_licenseplate')">
					<el-input v-model="carform.license" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cardialogFormVisible=false">{{$t('usersmanage.carsinfo_operate_modify_cancel')}}</el-button>
				<el-button type="primary" @click="updateUserCar()">{{$t('usersmanage.carsinfo_operate_modify')}}</el-button>
			</div>
		</el-dialog>
		<!-- 用户密码框 -->
		<!-- 用户框 -->
		<el-dialog :title="this.$t('usersmanage.modifypwd_title')" :visible.sync="pwdDialogFormVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="pwdForm">
				<el-form-item :label="this.$t('usersmanage.modifypwd_phone')" :label-width="formLabelWidth">
					<el-input v-model="pwdForm.phone" autocomplete="off" @input="change($event)" :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.modifypwd_newpwd')" :label-width="formLabelWidth">
					<el-input v-model="pwdForm.newUserPwd" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('usersmanage.modifypwd_newpwdagain')" :label-width="formLabelWidth">
					<el-input v-model="pwdForm.newUserPwd2" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="exitUserPwd()">{{$t('usersmanage.modifypwd_cancel')}}</el-button>
				<el-button type="primary" @click="toUserPwd()">{{$t('usersmanage.modifypwd_modifypwd')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				users: [{
					userId: '',
					username: '',
					phone: '',
					email: '',
					image: '',
					createTime: '',
					equipment: 0,
					haveCar: 0
				}],
				carInfo: [{
					id: '',
					brand: '',
					year: '',
					configuration: '',
					createTime: '',
					vin: '',
					license: ''
				}],
				table: false,
				length: 5,
				page: 1,
				total: 100,
				username: '',
				userId: '',
				search: '',
				dialogTitle: '新增用户',
				dialogFormVisible: false,
				pwdDialogFormVisible: false,
				cardialogFormVisible: false,
				form: {
					username: '',
					password: '',
					phone: '',
					image: ''
				},
				carform: {
					id: '',
					brandC: '',
					brandE: '',
					year: '',
					configuration: '',
					vin: '',
					license: ''
				},
				pwdForm: {
					phone: '',
					newUserPwd: '',
					newUserPwd2: ''
				},
				formLabelWidth: '120px',
				btnName: ''

			};
		},
		created() {
			this.reload();
		},
		methods: {
			change(e) {
				this.$forceUpdate();
			},
			// 初始化页面
			reload() {
				let that = this;
				let length = that.length;
				let page = that.page;
				let search = that.search
				if (that.search != '') {
					that.getRequest('/tpa-api/manageUser/getAllUserOrPhone?phone=' + that.search + '&page=' + page +
							'&length=' +
							length, null)
						.then(resp => {
							that.users = resp.result;
						});
				} else {
					that.getRequest('/tpa-api/manageUser/getAllUserOrPhone?length=' + length + '&page=' + page, null).then(
						resp => {
							if (resp) {
                console.log("getAllUserOrPhone successful")

								that.users = resp.result;
								that.total = resp.total;
                for (let i = 0; i < resp.total; i++) {
                  console.log(that.users[i].email)
                }
							}
						});
				}

			},
			tableClick: function(userId, username, flag) {
				let that = this;
				that.getRequest('/tpa-api/manageUser/getAllUserCar/' + userId, null).then(resp => {
					if (resp) {
						that.userId = userId;
						that.username = username;
						that.carInfo = resp.result;
					}
					that.table = flag;
				});
			},
			updateOneCar: function(row) {
				this.carform.id = row.id;
				this.carform.brandC = row.brandC;
				this.carform.brandE = row.brandE;
				this.carform.year = row.year;
				this.carform.configuration = row.configuration;
				this.carform.vin = row.vin;
				this.carform.license = row.license;
				this.cardialogFormVisible = true;
			},
			updateUserCar: function() {
				// 发送ajax请求修改车辆vin和license
				let carform = this.carform;
				let that = this;
				let data = {
					id: carform.id,
					vin: carform.vin,
					license: carform.license
				}
				that.postRequest('/tpa-api/manageUser/updateUserCar', data).then(resp => {
					if (resp.code == 200) {
						that.cardialogFormVisible = false;
						that.table = false;
					}
				});
			},
			deleteOneCar: function(id) {
				// 跳出确认框
				let that = this;
				that.$confirm(this.$t('usersmanage.carsinfo_operate_deletewarn'), this.$t('notification.title'), {
					confirmButtonText: this.$t('usersmanage.carsinfo_operate_deletewarnyes'),
					cancelButtonText: this.$t('usersmanage.carsinfo_operate_deletewarnno'),
					type: 'warning'
				}).then(() => {
					// 发送ajax请求删除数据
					that.deleteRequest('/tpa-api/manageUser/deleteUserCarById/' + id, null).then(resp => {
						if (resp.code == 200) {
							that.page = 1;
							that.length = 5;
							// 重新加载
							that.reload();
						}
					});
				}).catch(() => {
					that.$message({
						type: 'info',
						message: this.$t('usersmanage.deletewarnnomessage')
					});
				});
			},
			// 分页功能
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.length = val;
				this.reload();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.reload();
			},
			// 搜索
			userSearch() {
				let that = this;
				let search = that.search;
				let page = 1;
				let length = that.length;
				that.getRequest('/tpa-api/manageUser/getAllUserOrPhone?target=' + search + '&page=' + page + '&length=' +
						length, null)
					.then(resp => {
						that.users = resp.result;
					});
			},
			// 打开新增用户
			openInsertUser() {
				this.dialogFormVisible = true;
				this.dialogTitle = this.$t('usersmanage.insertuser_title');
				this.form = {
					username: '',
					password: '',
					phone: '',
					image: ''
				};
				this.btnName = this.$t('usersmanage.btninsertuser')

			},
			// 打开修改用户
			openUpdateUser() {
				this.dialogFormVisible = true;
				this.dialogTitle = this.$t('usersmanage.modifyinfo_title');
				this.form = {};
				this.btnName = this.$t('usersmanage.modifyinfo_modify')
			},
			openUpdatePwd() {
				this.pwdDialogFormVisible = true;
				this.pwdForm = {};
			},
			// 添加用户
			toUser() {
				let that = this;
				if (that.btnName == this.$t('usersmanage.btninsertuser')) {

					let data = {
						username: that.form.username,
						userPhone: that.form.phone,
						userPassword: that.form.password,
						userEquipment: 0
					}
					that.postRequest('/tpa-api/manageUser/addOneUser', data).then(resp => {
						if (resp.code == 200) {
							that.reload();
						}
					});
				} else if (that.btnName == this.$t('usersmanage.modifyinfo_modify')) {
					let form = that.form;
					let data = {
						userId: form.userId,
						username: form.username,
						phone: form.phone,
						equipment: form.equipment,
						enabled: form.enabled == true ? 1 : 0
					}
					that.postRequest('/tpa-api/manageUser/updateUserBase', data).then(resp => {
						if (resp.code == 200) {
							that.reload();
						}
					});
				}

				that.dialogFormVisible = false;
			},
			// 修改用户密码
			toUserPwd() {
				let that = this;
				// 两次密码不相同
				if (that.pwdForm.newUserPwd != that.pwdForm.newUserPwd2) {
					this.$message.error(this.$t('usersmanage.modifypwd_difpwd'));
					return;
				}
				let updPwd = {
					phone: that.pwdForm.phone,
					password: that.pwdForm.newUserPwd,
					allowUpd: 'allowUserUpdPwd'
				}
				that.postRequest('/tpa-api/manageUser/updateUserPwd', updPwd).then(resp => {
					if (resp.code == 200) {
						this.reload();
						that.pwdDialogFormVisible = false;
					}
				})
			},
			exitUserPwd() {
				this.pwdDialogFormVisible = false;
				this.$message(this.$t('notification.usermanagemessage1'));
			},
			updateUserInfo(row) {
				this.openUpdateUser();
				this.form.userId = row.userId;
				this.form.username = row.username;
				this.form.phone = row.phone;
				this.form.equipment = row.equipment;
				this.form.enabled = row.enabled == 1 ? true : false;
			},
			updateUserPwd(row) {
				this.openUpdatePwd();
				this.pwdForm.phone = row.phone;
			},
			deleteUserInfo(id) {
				this.$confirm(this.$t('usersmanage.operate1_deletewarn'), this.$t('notification.title'), {
					confirmButtonText: this.$t('usersmanage.operate1_deletewarnyes'),
					cancelButtonText: this.$t('usersmanage.operate1_deletewarnno'),
					type: 'warning'
				}).then(() => {
					this.deleteRequest('/tpa-api/manageUser/deleteOneUser/' + id, null)
						.then(resp => {
							if (resp.code == 200) {
								this.reload();
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('usersmanage.deletewarnnomessage')
					});
				});
			}
		}
	};
</script>
<style scoped>
	.avatar {
		height: 50px;
	}

	.pagination {
		display: flex;
		float: left;
		margin-left: 10px;
		margin-top: 40px;
	}

	.search {
		width: 30%;
		height: 50px;

	}

	.header {
		display: flex;
		flex-direction: row;
	}

	.btnInsert {
		margin-left: 50px;
		height: 36px;
		font-size: 10px;
		line-height: 10px;
		float: right;
	}

	.btn {
		cursor: pointer;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar1 {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
